import Link from "next/link"

const TestSSOButton = () => {
  return (<div><Link href="/oauth/test/sign-in" data-testid="test-sso-button">Test SSO</Link></div>)
    ;
}

export default TestSSOButton;